var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locations-map",style:({
    height: `calc(${_vm.windowHeight}px - ${_vm.sidebarLocations}px)`,
  })},[_c('LazyMoleculesCommonMoleculeGoogleMap',{ref:"map",staticClass:"landing-map-container",style:({
      height: `calc(${_vm.windowHeight}px - ${_vm.sidebarLocations}px)`,
    }),attrs:{"map-config":_vm.mapConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }